module.exports = __webpack_public_path__ + "static/media/message_notify.09868eb0.mp3";